import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/es/Checkbox/Checkbox";
import Paper from "@material-ui/core/Paper/Paper";
import moment from "moment";
import React from "react";
import {Link} from "react-router-component";

import {SegmentedControl} from "segmented-control";
import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import Sensor from "../Sensor";
import * as API from "../util/api";
import * as Provider from "../util/provider";
import * as Render from "../util/Render";
import * as Util from "../util/util";
import * as Variant from "../util/variant";
import GraphView from "./GraphView";
import VLComponent from "./VLComponent";

am4core.useTheme(am4themes_animated);

export default class SystemListScreen extends VLComponent {

    constructor() {
        super();
        this.state = {
            loaded: false,
            sensors: [],
            groups: [],
            sort: 0,
            search: "",
            variant: 0,
            show_ea: false,
            show_nrw: false,
            distanceRange: 20
        };
    }

    componentDidMount() {
        this.setState({group: this.props.group});
        API.POST("systems/list", {show_ea: 1, show_nrw: 1}, result => {
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
                this.setState({refreshTime: moment().format("HH:mm:ss")});
            }
        });

        API.POST("groups/list", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                this.setState({groups: result.result.groups.map(g => g.name), offline: result.result.sensors_offline});
            }
        });

        Util.getLocation(pos => {
            this.setState({lat: pos.coords.latitude, lng: pos.coords.longitude});
        });
    }

    render() {
        return (
            <div>
                <ActionBar title={this.state.app_name}/>
                {this.renderTextAlert()}
                <div id="content"
                     style={{width: "100%", display: this.state.loaded ? "flex" : "none", padding: "0 30px"}}>
                    <div style={{width: 700, marginRight: 30, maxWidth: "35vw"}}>
                        {this.renderFilters()}
                    </div>
                    <div style={{flex: 50}}>
                        <div style={{
                            height: "calc(100vh - 72px)",
                            overflowY: "auto",
                            display: this.displaying().length > 0 ? "block" : "none"
                        }}>
                            {this.renderSystems()}
                        </div>
                        <div style={{
                            height: "calc(100vh - 72px)",
                            overflowY: "auto",
                            display: this.displaying().length === 0 ? "block" : "none",
                            textAlign: "center"
                        }}>
                            <p style={{padding: 64, textAlign: "center"}}>No results found</p>
                            <Button color="primary"
                                    variant="contained" onClick={this.clearFilters}
                                    className="vl-button">Reset Search</Button>
                        </div>
                    </div>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    clearFilters = () => {
        this.setState({search: "", group: 0, variant: 0});
    };

    renderFilters = () => {
        let groups = this.state.groups.filter(g => g != null && g != "" && g != "null");
        if (groups.length < 1) {
            return;
        }
        let groupItems = groups.map((g, i) => ({label: g, value: i, default: this.state.group == i}));

        return (
            <div>
                <Paper style={{marginTop: 16, maxHeight: "calc(100vh - 100px)", overflowY: "auto"}}>
                    <div style={{textAlign: "center", padding: 32}}>
                        <img style={{width: "50%"}} src={this.state.app_image}/>

                        {groups.length > 1 && <SegmentedControl
                            name="group"
                            options={groupItems}
                            setValue={group => this.setState({group: group})}
                            style={{width: "100%", color: window.primary}}/>}

                        <SegmentedControl
                            name="variant"
                            options={[
                                {
                                    label: "All",
                                    value: "0",
                                    default: this.state.variant == 0
                                },
                                {
                                    label: "GSM Cam",
                                    value: "1",
                                    default: this.state.variant == Variant.CAMERA
                                },
                                {
                                    label: "Gauge",
                                    value: "2",
                                    default: this.state.variant == Variant.GAUGE
                                },
                                {
                                    label: "IP Cam",
                                    value: "3",
                                    default: this.state.variant == Variant.IP_CAMERA
                                }
                            ]}
                            value={this.state.variant}
                            setValue={variant => this.setState({variant})}
                            style={{width: "100%", color: window.primary}}/>

                        <input className="vl-input" style={{width: "100%"}} placeholder="Search" name="search"
                               onChange={this.handleSearchChange} value={this.state.search}/>
                        <br/><br/>

                        <p>EA / NRW Distance Range: {this.currentDistanceRange()}</p>
                        <input type="range" min="1" max="41" step="1" className="wide" name="distanceRange"
                               onChange={this.handleInputChange} value={this.state.distanceRange}/>
                        <br/><br/>
                        <select name="sort" onChange={this.handleInputChange} style={{width: "100%"}}
                                value={this.props.sort}>
                            <option value={0}>Sort Alphabetically</option>
                            <option value={1}>Sort by Distance</option>
                            <option value={2}>Sort by Flood Risk</option>
                        </select>
                        <br/><br/>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Checkbox checked={this.state.show_ea} onChange={this.handleInputChange} name="show_ea"/>
                            <p style={{flex: 1, textAlign: "left"}}>Show EA Sensors</p>
                            <i className="material-icons hoverable vl-text" onClick={this.showEaInfo}>info</i>
                        </div>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Checkbox checked={this.state.show_nrw} onChange={this.handleInputChange} name="show_nrw"/>
                            <p style={{flex: 1, textAlign: "left"}}>Show NRW Sensors</p>
                            <i className="material-icons hoverable vl-text" onClick={this.showEaInfo}>info</i>
                        </div>

                        <p>{this.vlSensors().length - this.state.offline} / {this.vlSensors().length} systems online</p>
                        <p>Page Refreshed {this.state.refreshTime}</p>

                        <VLButton href={"/matrix/" + this.state.group} className="top8" style={{width: "100%"}}
                                  title="Camera Matrix"/>
                        <VLButton href="/map" className="top8" style={{width: "100%"}} title="Map View"/>
                    </div>
                </Paper>

            </div>
        );
    };

    currentDistanceRange = () => {
        if (this.state.distanceRange == 41) {
            return "All";
        }
        return this.state.distanceRange + "km";
    };

    vlSensors = () => {
        return this.state.sensors.filter(e => e.provider == Provider.VL);
    };

    handleSearchChange = (e) => {
        this.handleInputChange(e);
    };

    displaying = () => {
        return this.state.sensors.filter(s => {
            return s.system_group == this.state.group || this.state.group == 0;
        }).filter(s => {
            return s.variant == this.state.variant || this.state.variant == 0;
        }).filter(s => {
            Object.setPrototypeOf(s, Sensor.prototype);
            return s.matches(this.state.search);
        }).filter(s => {
            return s.provider == Provider.VL || (s.provider == Provider.EA && this.state.show_ea) || (s.provider == Provider.NRW && this.state.show_nrw);
        }).filter(s => {
            return s.provider == Provider.VL || this.state.lat == null || this.state.distanceRange == 41 || s.getDistanceRaw(this.state) < this.state.distanceRange;
        }).sort((a, b) => {
            Object.setPrototypeOf(a, Sensor.prototype);
            Object.setPrototypeOf(b, Sensor.prototype);
            if (this.state.sort == 1) {
                if (a.getDistance(this.state) < b.getDistance(this.state)) {
                    return -1;
                }
                if (a.getDistance(this.state) > b.getDistance(this.state)) {
                    return 1;
                }
            }
            if (a.shouldRed()) {
                return -1;
            }
            if (b.shouldRed()) {
                return 1;
            }
            if (a.isOnline() && !b.isOnline()) {
                return 1;
            }
            if (b.isOnline() && !a.isOnline()) {
                return -1;
            }
            if (a.sensor_name < b.sensor_name) {
                return -1;
            }
            return 1;
        });
    };

    renderSystems = () => {
        return this.displaying().map(this.renderSystem);
    };

    renderSystem = (system) => {
        Object.setPrototypeOf(system, Sensor.prototype);
        let link = system.variant != Variant.GAUGE ? "/camera" : "/sensor";
        if (system.provider != Provider.VL) {
            link = link + "/" + system.provider;
        }
        return (
            <Link href={link + "/" + system.sensor_id} style={{textDecoration: "none"}}>
                <div style={{
                    marginTop: 8,
                    borderRadius: 16,
                    background: system.getBackground(),
                    color: "white",
                    padding: 16,
                    position: "relative"
                }}>
                    {system.variant != Variant.GAUGE ? this.renderCamera(system) : this.renderSensor(system)}
                    {system.isOnline() ? [] : Render.overlay("OFFLINE", "rgba(0,0,0,0.2)")}
                    {system.isOnline() && system.shouldRed() ? Render.overlay("WARNING", "rgba(0,0,0,0.2)") : []}
                </div>
            </Link>
        );
    };

    renderSensor = (sensor) => {
        Object.setPrototypeOf(sensor, Sensor.prototype);
        if (sensor.provider != Provider.VL) {
            return this.renderEaSensor(sensor);
        }
        const fidoAlarms = (
            <>
                <p>{Util.warningLevelName()} Level: {sensor.warning_level}m</p>
                <p>{Util.actConLevelName()} Level: {sensor.act_con_level}m</p>
                <p>{Util.alertLevelName()} Level: {sensor.alert_level}m</p>
            </>
        );
        const nonFidoAlarms = null;
        const levels = sensor.fido_alarms_en ? fidoAlarms : nonFidoAlarms;
        return (
            <div style={{display: "flex"}}>
                <div>
                    <p><b>{sensor.sensor_name}</b></p>
                    {levels}
                </div>
                <div style={{flex: 1}}>
                    <GraphView graph_data={sensor.graph_data} hideAxis={true}/>
                </div>

                <div style={{textAlign: "right"}}>
                    <p>Last Updated: {sensor.sensor_comms}</p>
                    <p><i>{sensor.getDirection()}</i></p>
                    <p>{sensor.getDistance(this.state)} </p>
                </div>
            </div>
        );
    };

    renderEaSensor = (sensor) => {
        return (
            <div style={{display: "flex"}}>
                <div>
                    <p><b>{sensor.sensor_name}</b></p>
                    <p>{sensor.riverName}</p>
                    <p>{sensor.catchment}</p>
                </div>
                <div style={{flex: 1}}>

                </div>

                <div style={{textAlign: "right"}}>
                    <p>Last Updated: {sensor.sensor_comms}</p>
                    {Render.image(sensor.provider, 80)}
                    <p>{sensor.getDistance(this.state)} </p>
                </div>
            </div>
        );
    };

    setupChart = (sensor) => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(sensor.sensor_id + "graph", am4charts.XYChart);

        chart.paddingRight = 20;
        chart.colors.list = [am4core.color("#FFFFFF")];

        let data = [];
        if (sensor.graph_data == null) {
            return;
        }
        sensor.graph_data.forEach(d => {
            data.push({date: new Date(d.timestamp * 1000), value: d.level});
        });

        chart.data = data;

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;

        dateAxis.renderer.grid.template.disabled = true;
        valueAxis.renderer.grid.template.disabled = true;
        dateAxis.renderer.labels.template.disabled = true;
        valueAxis.renderer.labels.template.disabled = true;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";
    };

    renderCamera = (camera) => {
        Object.setPrototypeOf(camera, Sensor.prototype);
        return (
            <div style={{display: "flex", alignItems: "center"}}>
                {this.renderCameraLhs(camera)}
                {this.renderMiddleView(camera)}
                <div style={{flex: 1, textAlign: "right"}}>
                    <p>Last Updated: {camera.comms()}</p>
                    <p>Updates every {camera.update} mins</p>
                    <p>Next Update: {camera.nextComms()}</p>
                    <p>{camera.getDistance(this.state)} </p>
                </div>
            </div>
        );
    };

    renderCameraLhs = (camera) => {
        if (camera.variant == Variant.IP_CAMERA) {
            return <div style={{flex: 1}}>
                <p><b>{camera.sensor_name}</b></p>
                <p>{camera.cameraType()}</p>
                <p>{this.state.groups[camera.system_group]}</p>
            </div>;
        }

        return <div style={{flex: 1}}>
            <p><b>{camera.sensor_name}</b></p>
            <p>{camera.cameraType()}</p>
            <p>{this.state.groups[camera.system_group]}</p>
            <p>Solar: {camera.camera_solar}V</p>
            <p><span
                style={{verticalAlign: "middle"}}> GSM Signal: </span>{Render.gsmImage(camera.gsm_signal, "_white")}
            </p>
        </div>;

    };

    renderMiddleView = (camera) => {
        if (!camera.isHiRes()) {
            return;
        }
        return (
            <div style={{
                flex: 1,
                display: camera.isHiRes() ? "block" : "none",
                justifyContent: "center",
                textAlign: "center"
            }}>
                <p>Level</p>
                <i style={{fontSize: 64}} className="material-icons">{this.hiRes(camera).getDirectionIcon()}</i>
                <p>{this.hiRes(camera).getDirection()}</p>
            </div>
        );
    };

    hiRes = (camera) => {
        let s = camera.hi_res_sensor;
        Object.setPrototypeOf(s, Sensor.prototype);
        return s;
    };

    showEaInfo = () => {
        let text = `
        The Environment Agency, Scottish Environment Protection Agency and Natural Resources Wales monitor river levels across the British Isles. The data is recorded at 15 minute intervals and reported according to operational needs.

            As the measurements are sent straight to our database they are unverified and may occasionally be incorrect. There may also be occasions when data will not have been collected from a monitoring station by the Environment Agency, Scottish Environment Protection Agency or Natural Resources Wales, in these situations this is outside Vision Link Ltd control.

            Whilst every effort has been made to ensure the accuracy of the information provided, neither the Environment Agency, Scottish Environment Protection Agency, Natural Resources Wales, nor Vision Link Ltd, its employees or agents can be held responsible for any inaccuracies or omissions, whether caused by negligence or otherwise.

            Vision Link Ltd Smartphone Applications are award winning technology with the latest river level and camera data from Environment Agency, the Scottish Environment Protection Agency and Natural Resources Wales.

        `;
        this.showTextAlert("Level Sensor Information", text, "DISMISS")
    }

}